/** Scene taps commit on release. A second scene finger invalidates both, without owning the joystick. */
export class SceneTap {
  private point: {
    id: number;
    x: number;
    y: number;
    time: number;
    cancelled: boolean;
  } | null = null;
  begin(id: number, x: number, y: number, time: number) {
    if (this.point) {
      this.point.cancelled = true;
      return;
    }
    this.point = { id, x, y, time, cancelled: false };
  }
  move(id: number, x: number, y: number) {
    if (
      this.point?.id === id &&
      Math.hypot(x - this.point.x, y - this.point.y) > 12
    )
      this.point.cancelled = true;
  }
  release(id: number, x: number, y: number, time: number) {
    const p = this.point;
    if (p?.id !== id) return false;
    this.point = null;
    return (
      !p.cancelled && time - p.time < 450 && Math.hypot(x - p.x, y - p.y) <= 12
    );
  }
  cancel() {
    this.point = null;
  }
}
